import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import DateAndTime$1 from './DateAndTime.js';

const DateAndTimeContainer = (_param)=>{
    var { date , startTime , endTime  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "date",
        "startTime",
        "endTime"
    ]);
    const { dateTime: { formatLongDate , formatTime  } ,  } = useIntl();
    const formattedDate = React.useMemo(()=>{
        if (date) {
            return formatLongDate(date);
        }
    }, [
        date,
        formatLongDate
    ]);
    const formattedTime = React.useMemo(()=>{
        if (startTime && endTime) {
            return `${formatTime(startTime)} - ${formatTime(endTime)}`;
        }
    }, [
        startTime,
        endTime,
        formatTime
    ]);
    return /*#__PURE__*/ React.createElement(DateAndTime$1, swcHelpers.extends({}, rest, {
        formattedDate: formattedDate,
        formattedTime: formattedTime
    }));
};
var DateAndTime = DateAndTimeContainer;

export { DateAndTime as default };
//# sourceMappingURL=DateAndTimeContainer.js.map
